// extracted by mini-css-extract-plugin
export var avatarContainer = "_ic-0";
export var avatarTypingWave = "_ic-i";
export var gray = "_ic-f";
export var green = "_ic-c";
export var icon = "_ic-9";
export var image = "_ic-1";
export var lg = "_ic-6";
export var md = "_ic-5";
export var presenceDot = "_ic-b";
export var red = "_ic-d";
export var sm = "_ic-4";
export var status = "_ic-a";
export var typingDot = "_ic-h";
export var typingPill = "_ic-g";
export var xl = "_ic-7";
export var xs = "_ic-3";
export var xxl = "_ic-8";
export var xxs = "_ic-2";
export var yellow = "_ic-e";